import React, { useState, useEffect } from "react";
import { MdOutlineErrorOutline } from "react-icons/md";
import { useAppDispatch, useAppSelector } from "../../../useStore";
import FilterListIcon from "@mui/icons-material/FilterList";
import swal from "sweetalert";
import {
  EntriesPerPage,
  Search,
  TableProgressBar,
} from "../../../components/TableOptions";
import Pagination from "../../../components/Pagination";
import moment from "moment";
import { Link } from "react-router-dom";
import { Button } from "@material-ui/core";
import { applicationassigned, reset } from "../../../features/Applicant/applicantSlice";
import ScreeningUpdateModal from "../../../components/ModalComponents/ScreeningUpdateModal";
import { Toaster } from "react-hot-toast";


const HistoryScreeningTable = ({ pageHeader, headerTitles, statusButton, Status, }: any) => {

  const dispatch = useAppDispatch();
  const { applicationassigneddata,
    applicationassignedisLoading, applicationassignedisError, applicationassignedmessage
  } = useAppSelector((state: any) => state.applicant)



  useEffect(() => {
    dispatch(applicationassigned())
  }, [dispatch])

  useEffect(() => {
    if (applicationassignedisError) {
      swal({
        title: "error",
        text: applicationassignedmessage,
        icon: "error"
      })
      dispatch(reset())
    }
  }, [dispatch, applicationassignedisError, applicationassignedmessage])


  const [datas, setDatas] = useState([]);
  const [searchItem, setSearchItem] = useState("");
  const [entriesperpage, setEntriesPerPage] = useState(() => {
    return "10";
  });

  const evaluation = applicationassigneddata?.data?.filter((obj: any) => {
    return obj?.ScreeningLog?.screeningStatus === "COMPLETED"
  })



  useEffect(() => {
    const result = evaluation?.filter((item: any) =>
      item?.firstName?.toLowerCase()?.includes(searchItem)
    );
    setDatas(result);

  }, [evaluation, searchItem]);




  const [displayData, setDisplayData] = useState([]);

  return (
    <div>
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 5000,
          error: {
            duration: 20000,
          },
        }}
      />
      <section className="md-ui component-data-table">
        <header className="main-table-header">
          <div className="main-table-search-container">
            <h1 className="table-header--title">{pageHeader}</h1>
            <Search
              searchItem={searchItem}
              setSearchItem={setSearchItem}
              placeholder={pageHeader}
            />
            <div>
              <EntriesPerPage
                data={datas}
                entriesperpage={entriesperpage}
                setEntriesPerPage={setEntriesPerPage}
              />
            </div>
            <span className="table-header--icons">
              <FilterListIcon />
            </span>
          </div>
        </header>
        <div className="main-table-wrapper">
          <table className="main-table-content">
            <thead className="data-table-header">
              <tr className="data-table-row">
                {headerTitles.map((title, i) => (
                  <td
                    className="table-datacell datatype-string headerTitles"
                    key={i}
                  >
                    {title}
                  </td>
                ))}
              </tr>
            </thead>
            <tbody className="data-table-content">
              {applicationassignedisLoading ? (
                <tr>
                  <td className="table-msg" colSpan={12}>
                    <p>Fetching request...</p>
                    <div id="container-progressbar-container">
                      <TableProgressBar />
                    </div>
                  </td>
                </tr>
              ) : displayData?.length === 0 ||
                displayData?.length === undefined ? (
                <tr>
                  <td className="table-msg" colSpan={12}>
                    <MdOutlineErrorOutline size={75} />
                    <p>No Record found!</p>
                  </td>
                </tr>
              ) : (
                displayData?.map((item: any, i: any) => (
                  <tr className="data-table-row" key={i}>
                    <td className="table-datacell datatype-string">
                      <div className="dropdown">
                        <ScreeningUpdateModal
                          disabled={
                            item?.ScreeningLog?.screeningStatus === "PENDING"
                              ? false
                              : true
                          }
                          title={"Send for Screening"}
                          nametitle={item.title}
                          name={
                            item.firstName +
                            " " +
                            item.middleName +
                            " " +
                            item.LastName
                          }
                          id={item?.ScreeningLog?.id}
                        />
                      </div>
                    </td>
                    <td className="table-datacell datatype-numeric toggle">
                      {item.title}
                    </td>

                    <td className="table-datacell datatype-string">
                      {item.firstName + " " + item.LastName}
                    </td>

                    <td className="table-datacell datatype-string">
                      <Link
                        to={`/viewapplicants/${item?.id}`}
                        className="applicant-btn"
                      >
                        <Button className="view-job-profile">View</Button>
                      </Link>
                    </td>
                    <td className="table-datacell datatype-string">
                      {" "}
                      {moment(item?.createdAt).format("DD-MM-YYYY")}
                    </td>

                    <td className="table-datacell datatype-numeric">
                      <Button className={statusButton}>
                        {item?.ScreeningLog?.screeningStatus === "PENDING"
                          ? Status
                          : "COMPLETED"}
                      </Button>
                    </td>

                    <td className="table-datacell datatype-numeric">
                      {!item.phoneNumber ? "n/a" : item?.phoneNumber}
                    </td>
                    <td className="table-datacell datatype-numeric">
                      {item?.applicationStatus}
                    </td>

                    <td className="table-datacell datatype-numeric">
                      {!item.totalWorkExperience
                        ? "n/a"
                        : item?.totalWorkExperience + " years"}{" "}
                    </td>

                    <td className="table-datacell datatype-string">
                      {!item?.email ? "n/a" : item?.email}
                    </td>
                    <td className="table-datacell datatype-string">
                      {!item?.location ? "n/a" : item?.location}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <div className="table-footer">
          <div>
            <Pagination
              setDisplayData={setDisplayData}
              data={datas}
              entriesperpage={entriesperpage}
              Total={"Screening"}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default HistoryScreeningTable;